import vendorDashboardAPI from '@/utils/api/vendorDashboard';
import { genericError, genericSuccess } from '@/utils/alerts.service';
import Vue from 'vue';

export const urls = {
  namespaced: true,
  state: {
    urls: {},
    urlIntRequestButtonActive: false,
  },
  getters: {
    urls(state) {
      return state.urls;
    },
    urlIntRequestButtonActive(state) {
      return state.urlIntRequestButtonActive;
    },
  },
  mutations: {
    setUrls(state, data) {
      state.urls = data;
    },

    updateUrl(state, payload) {
      Vue.set(state.urls, payload.key, payload.value);
    },

    setIntRequestButtonActive(state, active) {
      state.urlIntRequestButtonActive = active;
    },
  },
  actions: {
    async fetchUrls({ dispatch, commit }) {
      return vendorDashboardAPI
        .getSettings()
        .then(data => {
          commit('setUrls', data);
          if (data.integrationsBtnUrl) {
            commit('setIntRequestButtonActive', true);
          }
        })
        .catch(() => {
          dispatch('showUserMessage', { ...genericError }, { root: true });
        });
    },

    async saveUrls({ dispatch, state }) {
      if (
        (!state.urls.directoryPage && !state.urls.integrationsDirectoryPage) ||
        state.urls.directoryPage == state.urls.integrationsDirectoryPage
      ) {
        return dispatch(
          'showUserMessage',
          {
            success: false,
            title: 'Oops!',
            message:
              'The Integrations directory page cannot be the same as the Agencies directory page.',
          },
          { root: true }
        );
      }

      if (state.urlIntRequestButtonActive && !state.urls.integrationsBtnUrl) {
        return dispatch(
          'showUserMessage',
          {
            success: false,
            title: 'Oops!',
            message:
              'Please make sure to provide the URL of the integration request button.',
          },
          { root: true }
        );
      }
      return vendorDashboardAPI
        .saveSettings(state.urls)
        .then(() => {
          dispatch('showUserMessage', { ...genericSuccess }, { root: true });
        })
        .catch(() => {
          dispatch('showUserMessage', { ...genericError }, { root: true });
        });
    },

    urlChange({ commit }, payload) {
      commit('updateUrl', payload);
      commit('settings/addDirtyTab', 'settings', { root: true });
    },
  },
};
